import {HarLog} from './harLog';
import {HttpRequest, HttpResponse} from '@angular/common/http';
import {HarEntry} from './harEntry';
import {HarService} from '../services/har.service';

export class Har {
    log: HarLog;

    constructor(harService: HarService, startDate: Date) {
      this.log = new HarLog(startDate);
    }

    addEntry(harService: HarService, request: HttpRequest<any>, response: HttpResponse<any>) {
      const newEntry = new HarEntry(harService, request, response);
      this.log.entries.push(newEntry);
    }
}
